import { ICreateDraftVetRequestPayload } from "@entities/aiWorkspace";
import { BriefDeliverableTaskUploadTypeEnum } from "@entities/brief/lib/constants";
import { FirebaseService } from "@shared/lib/services";
import {
  isImageFile,
  isVideoFile,
} from "@shared/ui/Editor/lib/editorFileTypes";

export async function filesToDraftAssets(files: File[]) {
  const mediaAssets = [];
  for (const file of files) {
    const url = await FirebaseService.uploadFileToFirebase(
      `draft/${Date.now()}`,
      file
    );
    const type = isImageFile(file)
      ? BriefDeliverableTaskUploadTypeEnum.Image
      : isVideoFile(file)
        ? BriefDeliverableTaskUploadTypeEnum.Video
        : BriefDeliverableTaskUploadTypeEnum.MediaLink;
    mediaAssets.push({ type, url, name: file.name });
  }
  return mediaAssets as ICreateDraftVetRequestPayload["mediaAssets"];
}
